export default "__VITE_ASSET__BwO_jWkS__"